var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgParameters = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "7px",
    viewBox: "0 0 12 7",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "globe")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0.-Menu-General-",
    transform: "translate(-34.000000, -949.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1.000000, 795.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Log-Out",
    transform: "translate(32.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.998265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-list",
    transform: "translate(0.000000, 0.199479)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 13.8974164 0 13.8974164 13.8974164 0 13.8974164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73717705,7.52776722 L2.89529509,7.52776722 L2.89529509,6.36964919 L1.73717705,6.36964919 L1.73717705,7.52776722 Z M1.73717705,9.84400329 L2.89529509,9.84400329 L2.89529509,8.68588526 L1.73717705,8.68588526 L1.73717705,9.84400329 Z M1.73717705,5.21153115 L2.89529509,5.21153115 L2.89529509,4.05341312 L1.73717705,4.05341312 L1.73717705,5.21153115 Z M4.05341312,7.52776722 L12.1602394,7.52776722 L12.1602394,6.36964919 L4.05341312,6.36964919 L4.05341312,7.52776722 Z M4.05341312,9.84400329 L12.1602394,9.84400329 L12.1602394,8.68588526 L4.05341312,8.68588526 L4.05341312,9.84400329 Z M4.05341312,4.05341312 L4.05341312,5.21153115 L12.1602394,5.21153115 L12.1602394,4.05341312 L4.05341312,4.05341312 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgParameters, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/parameters.f08fd300.svg";
export { ForwardRef as ReactComponent };